(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-services"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SEL = '[data-bs-carousel]';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function BsCarousel(root) {
      var self = this;
      this.root = root;
      this.viewport = root.querySelector('[data-bs-viewport]');
      this.track = root.querySelector('[data-bs-track]');
      this.slides = Array.prototype.slice.call(this.track.children);
      this.prev = root.querySelector('[data-bs-prev]');
      this.next = root.querySelector('[data-bs-next]');
      this.dots = root.querySelector('[data-bs-dots]');
      this.index = 0;
      this.max = 0;
      this.timer = null;
      this.dotCount = -1;
      this.autoplay = root.dataset.autoplay === 'true' && !reduceMotion && !(window.Shopify && window.Shopify.designMode);
      this.speed = (parseFloat(root.dataset.speed) || 5) * 1000;
      this.loop = root.dataset.loop === 'true';
      this.dragged = false;

      if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1, true); });
      if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1, true); });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self.go(self.index - 1, true); }
        if (e.key === 'ArrowRight') { self.go(self.index + 1, true); }
      });

      // Swipe / drag
      var startX = null;
      this.viewport.addEventListener('pointerdown', function (e) { startX = e.clientX; self.dragged = false; });
      this.viewport.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) {
          self.dragged = true;
          self.go(self.index + (dx < 0 ? 1 : -1), true);
        }
      });
      this.viewport.addEventListener('pointercancel', function () { startX = null; });
      this.viewport.addEventListener('click', function (e) {
        if (self.dragged) { e.preventDefault(); e.stopPropagation(); self.dragged = false; }
      }, true);

      // Pause autoplay on interaction
      root.addEventListener('mouseenter', function () { self.stopAuto(); });
      root.addEventListener('mouseleave', function () { self.startAuto(); });
      root.addEventListener('focusin', function () { self.stopAuto(); });
      root.addEventListener('focusout', function () { self.startAuto(); });

      this.measure(false);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(function () { self.measure(false); });
        this.ro.observe(this.viewport);
      } else {
        this.onResize = function () { self.measure(false); };
        window.addEventListener('resize', this.onResize);
      }
      this.startAuto();
    }

    BsCarousel.prototype.measure = function (animate) {
      var d = this.root.dataset;
      var count = this.slides.length;
      var w = this.viewport.clientWidth;
      var bp = window.innerWidth;
      var ratioSetting = parseFloat(d.ratio) || 1;
      var v, r;

      if (bp >= 990) { v = parseFloat(d.desktop) || 3; r = ratioSetting; }
      else if (bp >= 750) { v = parseFloat(d.tablet) || 2; r = 1 + (ratioSetting - 1) * 0.6; }
      else { v = parseFloat(d.mobile) || 1; r = v >= 2 ? 1 + (ratioSetting - 1) * 0.4 : 1; }

      if (v > count) v = count;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      var gaps = Math.max(0, Math.ceil(v) - 1);

      this.w = w;
      this.gap = gap;
      this.r = r;
      this.u = (w - gap * gaps) / (r + v - 1);
      this.max = Math.max(0, count - Math.floor(v));
      if (this.index > this.max) this.index = this.max;

      this.root.classList.toggle('bs-wide', r > 1.05);

      if (!animate) {
        var root = this.root;
        root.classList.add('bs-no-anim');
        this.render();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { root.classList.remove('bs-no-anim'); });
        });
      } else {
        this.render();
      }
      this.buildDots();
      this.updateNav();
    };

    BsCarousel.prototype.render = function () {
      var self = this;
      var n = this.slides.length;
      var widths = this.slides.map(function (s, i) { return i === self.index ? self.r * self.u : self.u; });
      var before = 0;
      for (var i = 0; i < this.index; i++) before += widths[i];
      before += this.gap * this.index;
      var total = widths.reduce(function (a, b) { return a + b; }, 0) + this.gap * (n - 1);
      var tx = Math.min(before, Math.max(0, total - this.w));
      this.track.style.transform = 'translate3d(' + (-tx) + 'px,0,0)';

      var pos = 0;
      this.slides.forEach(function (s, i) {
        s.style.width = widths[i] + 'px';
        s.classList.toggle('is-active', i === self.index);
        var left = pos - tx;
        var right = left + widths[i];
        var visible = right > 1 && left < self.w - 1;
        s.inert = !visible;
        s.setAttribute('aria-hidden', visible ? 'false' : 'true');
        pos += widths[i] + self.gap;
      });
    };

    BsCarousel.prototype.buildDots = function () {
      var self = this;
      if (!this.dots) return;
      var count = this.max + 1;
      if (count !== this.dotCount) {
        this.dots.innerHTML = '';
        for (var i = 0; i < count; i++) {
          (function (i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bs-dot';
            b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            b.addEventListener('click', function () { self.go(i, true); });
            self.dots.appendChild(b);
          })(i);
        }
        this.dotCount = count;
      }
      this.dots.style.display = count > 1 ? '' : 'none';
    };

    BsCarousel.prototype.updateNav = function () {
      var self = this;
      if (this.prev) this.prev.disabled = !this.loop && this.index <= 0;
      if (this.next) this.next.disabled = !this.loop && this.index >= this.max;
      if (this.dots) {
        Array.prototype.forEach.call(this.dots.children, function (d, i) {
          if (i === self.index) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
    };

    BsCarousel.prototype.go = function (i, user) {
      if (this.loop) {
        if (i > this.max) i = 0;
        else if (i < 0) i = this.max;
      } else {
        i = Math.max(0, Math.min(this.max, i));
      }
      this.index = i;
      this.render();
      this.updateNav();
      if (user) { this.stopAuto(); this.startAuto(); }
    };

    BsCarousel.prototype.startAuto = function () {
      var self = this;
      if (!this.autoplay || this.timer || this.max < 1) return;
      this.timer = setInterval(function () {
        if (self.index >= self.max) self.go(0); else self.go(self.index + 1);
      }, this.speed);
    };

    BsCarousel.prototype.stopAuto = function () {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    };

    BsCarousel.prototype.destroy = function () {
      this.stopAuto();
      if (this.ro) this.ro.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    };

    function init(scope) {
      (scope || document).querySelectorAll(SEL).forEach(function (el) {
        // Grid layout: no carousel JS needed
        if (el.dataset.layout === 'grid') return;
        if (!el._bs) el._bs = new BsCarousel(el);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();

    // Theme editor support
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll(SEL).forEach(function (el) { if (el._bs) el._bs.destroy(); });
    });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('.bs-slide');
      var root = e.target.closest(SEL);
      if (!slide || !root || !root._bs) return;
      root._bs.go(root._bs.slides.indexOf(slide));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
